/*
 * @Description: 
 * @Autor: pangting
 * @Date: 2024-12-12 16:21:51
 * @LastEditors: pangting
 * @LastEditTime: 2024-12-12 16:21:57
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
import {Methods} from "@newview/infrastructure";


export class ProjectTestQuestionNewV4Api extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-test-question-new-v4'
    }
    public saveRemark(params){
        return this.send(params,"saveRemark",Methods.POST)
    }


    public getEntityById(id){
        return this.send({id:id},"getEntityById",Methods.GET)
    }

    // async getChiefEngineerMess() {
    //     return this.send({},"getChiefEngineerMess",Methods.GET)
    // }
}